export enum BusinessInvalidityDuration {
  THREE_MONTHS = 'THREE_MONTHS',
  SIX_MONTHS = 'SIX_MONTHS',
  NINE_MONTHS = 'NINE_MONTHS',
  TWELVE_MONTHS = 'TWELVE_MONTHS',
}

export const BUSINESS_INVALIDITY_DURATION_VALUES = Object.values(
  BusinessInvalidityDuration
);

export const getBusinessInvalidityDurationLabel = (
  value: BusinessInvalidityDuration
) => {
  switch (value) {
    case BusinessInvalidityDuration.THREE_MONTHS:
      return $localize`3 mois`;
    case BusinessInvalidityDuration.SIX_MONTHS:
      return $localize`6 mois`;
    case BusinessInvalidityDuration.NINE_MONTHS:
      return $localize`9 mois`;
    case BusinessInvalidityDuration.TWELVE_MONTHS:
      return $localize`12 mois`;
  }
};
